const reactQuestions = [
  {
    question: "What is JSX?",
    options: [
      "JavaScript XML",
      "Java Syntax Extension",
      "JSON",
      "JavaScript Syntax Extension",
      "HTML Extension",
      "None of these",
    ],
    correctOption: 0,
  },
  {
    question: "What is a React Hook?",
    options: [
      "A function",
      "A way to manage state and side-effects in functional components",
      "A lifecycle method",
      "A JavaScript library",
      "A design pattern",
      "None of these",
    ],
    correctOption: 1,
  },
  {
    question: "What does the useState Hook do?",
    options: [
      "Manages component state",
      "Allows functional components to use class methods",
      "Creates a new component",
      "Fetches data from an API",
      "None of these",
      "All of these",
    ],
    correctOption: 0,
  },
  {
    question: "What is the purpose of the useEffect Hook?",
    options: [
      "To manage component lifecycle events",
      "To update the state",
      "To manage context",
      "To style components",
      "To handle events",
      "None of these",
    ],
    correctOption: 0,
  },
  {
    question:
      "How do you pass data from a parent component to a child component?",
    options: [
      "Through props",
      "Through state",
      "Through context",
      "Using hooks",
      "Using events",
      "All of these",
    ],
    correctOption: 0,
  },
  {
    question: "What is the virtual DOM?",
    options: [
      "A lightweight copy of the actual DOM",
      "A type of state management",
      "A component lifecycle method",
      "A way to style components",
      "None of these",
      "A JavaScript library",
    ],
    correctOption: 0,
  },
  {
    question: "What is a higher-order component (HOC)?",
    options: [
      "A function that takes a component and returns a new component",
      "A type of React component",
      "A component that manages state",
      "A component that uses hooks",
      "A lifecycle method",
      "None of these",
    ],
    correctOption: 0,
  },
  {
    question: "What is the purpose of keys in React lists?",
    options: [
      "To help React identify which items have changed",
      "To manage state",
      "To style components",
      "To optimize performance",
      "Both 1 and 4",
      "None of these",
    ],
    correctOption: 4,
  },
  {
    question:
      "What is the default port for a React application created with Create React App?",
    options: ["3000", "5000", "8080", "8000", "4000", "3001"],
    correctOption: 0,
  },
  {
    question: "How do you create a new component in React?",
    options: [
      "Using a function or class",
      "Using hooks",
      "By importing existing components",
      "By writing JSX",
      "Both 1 and 4",
      "All of these",
    ],
    correctOption: 4,
  },
];

export default reactQuestions;
